import { useEffect, useState } from 'react';

/** Chat sidebar mount is only supported at lg breakpoint and above. */
export const useCanMountChat = () => {
  const [canMountChat, setCanMountChat] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(min-width: 1024px)').matches : true
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 1024px)');
    const handleChange = () => setCanMountChat(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return canMountChat;
};
